
import React from 'react';
import { FINGER_COLORS } from '../../constants';

interface FingerKeyProps {
  fingerIndex: number;
  label: string;
}

const FingerKey: React.FC<FingerKeyProps> = ({ fingerIndex, label }) => (
  <div className="flex items-center space-x-2">
    <div className={`w-4 h-4 rounded-full ${FINGER_COLORS[fingerIndex]} border border-gray-400`}></div>
    <span className="font-mono font-semibold text-gray-700">{label}</span>
  </div>
);

export default FingerKey;
